<template>
  <div class="center-warp">
    <div class="inner">
      <span class="typeTitle">订单{{ billData.order_status_text }}</span>
      <div class="bg">
        <div style="padding: 0 15px">
          <!--        物品信息-->
          <div class="part1">
            <img :src="billData.product_pic" class="part1-img"/>
            <div class="desc">
              <div>{{ billData.product_name }}</div>
              <div>耗材编号: {{ billData.product_code }}</div>
              <div>分类: {{ billData.product_category_name }}{{
                  billData.product_is_dz == 1 ? ';定制耗材' : ';标准耗材'
                }}
              </div>
              <div>×{{ billData.product_quantity }}
                <template v-if="billData.order_status===3 && (billData.free_count > 0 || billData.paid_count > 0)">
                  (<span v-if="billData.free_count > 0 ">免费{{ billData.free_count }}件</span>
                  <span v-if="billData.paid_count > 0 && billData.free_count > 0">，</span>
                  <span v-if="billData.paid_count > 0 ">付费{{ billData.paid_count }}件</span>)
                </template>
              </div>
            </div>
          </div>
          <!--        订单信息-->
          <div class="part-info">
            <div class="part-info-title">订单信息</div>
            <div class="part-info-line"><span>订单状态：</span>{{ billData.order_status_text }}</div>
            <div class="part-info-line"><span>订单编号：</span>{{ billData.order_no }}</div>
            <div class="part-info-line"><span>领取用户：</span>{{ billData.doctor_name }}（医生）</div>
            <div class="part-info-line"><span>领取时间：</span>{{ billData.doctor_claim_time }}</div>
            <div v-if="billData.patient || billData.design_card_id" class="grey-bg">
              <div v-if="billData.patient" class="part-info-line">
                <span>关联病例：</span>{{ billData.patient.name }}（{{ billData.patient.no }}）
              </div>
              <div v-if="billData.patient" class="part-info-line"><span>套餐类型：</span>{{
                  billData.patient.confirm_first_case_type_text ? billData.patient.confirm_first_case_type_text : billData.patient.first_case_type_name
                }}
              </div>
              <div v-if="billData.design_card_id" class="d-flex-between">
                <div class="part-info-line">
                  <span>设计单编号：</span>{{ billData.sjd_card ? billData.sjd_card.card_date : '' }}
                </div>
                <div class="part-info-btn" @click="openSjDetail">查看设计单</div>
              </div>
            </div>
            <div class="part-info-line"><span>收货信息：</span>{{ billData.receiver_name }} {{ billData.receiver_phone }}
              {{ billData.receiver_province }} {{ billData.receiver_city }} {{ billData.receiver_district }}
              {{ billData.receiver_address }}
            </div>
          </div>
          <!--          审核信息-->
          <div v-if="billData.product_is_dz == 1" class="part-info part3">
            <div class="part-info-title">审核信息</div>
            <template v-if="billData.mentor_id">
              <div class="part-info-line">
                <span>导师确认时间：</span>{{ billData.mentor_status == 1 ? billData.mentor_confirm_time : '待确认' }}
              </div>
              <div class="part-info-line"><span>导师姓名：</span>{{ billData.mentor_name }}（导师）</div>
            </template>
            <template>
              <div class="part-info-line"><span>技师确认时间：</span><span
                :class="billData.process_status == 4 ? 'dispass' : ''">{{
                  billData.process_status == 4 ? '设计单未通过' : (billData.process_status == 1 ? billData.technician_confirm_time : '待确认')
                }}</span>
              </div>
              <div class="part-info-line">
                <span>技师姓名：</span>{{ billData.technician_name ? billData.technician_name + '（技师）' : '' }}
              </div>
            </template>

            <div v-if="billData.technician_latest_failAudit && [0,4].includes(billData.order_status)" class="grey-bg">
              <div class="part-info-line">
                <span>未通过原因：</span>
                <div>
                  <div class="limit-1" style="width: 800px">{{ billData.technician_latest_failAudit.content }}</div>
                  <div class="d-flex">
                    <div class="result-img">
                      <el-image :preview-src-list="[billData.technician_latest_failAudit.new_sjd_pz_img]"
                                :src="billData.technician_latest_failAudit.new_sjd_pz_img" fill="cover"
                                style="width: 84px; height: 84px">
                      </el-image>
                      <div class="result-img-tag">新设计单</div>
                    </div>
                    <div class="result-img">
                      <el-image :preview-src-list="[billData.technician_latest_failAudit.old_sjd_pz_img]"
                                :src="billData.technician_latest_failAudit.old_sjd_pz_img" fill="cover"
                                style="width: 84px; height: 84px">
                      </el-image>
                      <div class="result-img-tag">原设计单</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="part-info-bottom-go" @click="handleAuditLog">查看技师审核记录 >></div>
            </div>
          </div>
          <div v-if="billData.order_status == 1 || billData.order_status == 2 || billData.order_status == 3"
               class="part-info">
            <!-- 只有定制产品有发货信息 -->
            <div class="part-info-title">发货信息</div>
            <template v-if="billData.product_is_dz == 1">
              <div class="part-info-line"><span>加工类型：</span>{{ billData.type_text }} <span @click="downloadFile" v-if="billData.order_status >= 1 && billData.type == 2" style="line-height: 24px;font-size: 20px;margin: -2px 0 0 10px" class="part-info-btn el-icon-download"></span> </div>
              <div class="part-info-line"><span>加工进度：</span>{{
                  billData.jiagong_status == 2 ? '制作完成' : '制作中'
                }}
              </div>
            </template>
            <div class="d-flex-between">
              <div class="part-info-line"><span>物流信息：</span>
                <span v-if="billData.order_status===0">待确认</span>
                <span v-else-if="billData.order_status===1">待发货</span>
                <!--                已发货-->
                <span v-else-if="billData.order_status===2">{{ billData.express_company }}{{
                    billData.express_no
                  }}</span>
                <span v-else-if="billData.order_status===3">已完成</span>
                <span v-else-if="billData.order_status===7">已取消</span>
              </div>
              <div
                v-if="billData.order_status == 2 && (member.member_type == 5 || member.member_type == 4) && (member.id == billData.technician_id || member.id == billData.supplier_id)"
                class="part-info-btn"
                @click="handleDelivery(2)">修改物流号
              </div>
            </div>
            <div class="part-info-line"><span>发货时间：</span>{{ billData.delivery_time }}</div>
          </div>
        </div>
        <div class="bottom-part">
          <div v-if="member.member_type == 0 && billData.product_is_dz == 1 && billData.order_status == 0"
               class="bottom-part-btn-org"
               @click="cancelOrder">取消订单
          </div>
          <div v-if="member.member_type == 0 && billData.product_is_dz == 0 && billData.order_status == 1"
               class="bottom-part-btn-org"
               @click="cancelOrder">取消订单
          </div>

          <!-- 待确认的订单所有技师都能审核 -->
          <template
            v-if="billData.order_status == 0 && (billData.process_status == 0 || billData.process_status == null)&& member.member_type == 4 && (!billData.technician_id || billData.technician_id == member.id)">
            <div class="bottom-part-btn-white" @click="handleAudit">审核未通过</div>
            <div class="bottom-part-btn-org" @click="handleConfirm">订单确认</div>
          </template>
          <!-- 订单绑定的导师才能确认 -->
          <template
            v-if="billData.order_status == 0 && (billData.mentor_status == 0 || billData.mentor_status == null) && member.member_type == 1 && member.id == billData.mentor_id">
            <div class="bottom-part-btn-org" @click="handleConfirm">订单确认</div>
          </template>

          <!-- 订单绑定的供应商&技师才能发货-->
<!--          <div v-if="billData.order_status == 1 && (member.member_type == 5 || member.member_type == 4) && (member.id == billData.technician_id || member.id == billData.supplier_id)"-->
<!--            class="bottom-part-btn-org"-->
<!--            @click="handleDelivery(1)">订单发货-->
<!--          </div>-->
<!--          定制产品必须是该订单绑定的技师发货，非定制产品是供应商发货-->
          <div v-if="billData.order_status == 1 && ((member.member_type == 5 && billData.product_is_dz != 1)||( member.member_type == 4 && member.id == billData.technician_id)) "
               class="bottom-part-btn-org"
               @click="handleDelivery(1)">订单发货
          </div>
        </div>
      </div>

      <!-- 历史审核 todo-->
      <el-dialog :visible.sync="dialogVisible" custom-class="history-dialog" title="历史审核" width="834px">
        <div class="history-warp">
          <div v-for="item in auditLog" :key="item.id" class="history-item">
            <div class="part-info-line">
              <span>未通过原因：</span>
              <div>
                {{ item.content }}
                <div class="d-flex">
                  <div class="result-img">
                    <el-image :preview-src-list="[item.new_sjd_pz_img]" :src="item.new_sjd_pz_img" fill="cover"
                              style="width: 84px; height: 84px">
                    </el-image>
                    <div class="result-img-tag">新设计单</div>
                  </div>
                  <div class="result-img">
                    <el-image :preview-src-list="[item.old_sjd_pz_img]" :src="item.old_sjd_pz_img" fill="cover"
                              style="width: 84px; height: 84px">
                    </el-image>
                    <div class="result-img-tag">原设计单</div>
                  </div>
                </div>
                <div class="history-item-time">{{ item.created_at.substr(0, 16) }}</div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 设计单详情 -->
      <el-dialog :visible.sync="showDetailDialog" custom-class="take-dialog" title="设计单详情" top="5vh" width="834px">
        <div class="take-dialog-bottom"
             style="justify-content: space-between">
          <div class="d-flex" style="width: fit-content">
            <div class="add-card-data" v-if="billData.patient"  style="width: fit-content">
              <span>{{ billData.patient.confirm_first_case_type_text ? '确认套餐类型' : '期望套餐类型' }}：</span><span
              class="black-14">{{
                billData.patient.confirm_first_case_type_text ? billData.patient.confirm_first_case_type_text : billData.patient.first_case_type_name
              }}</span></div>
            <div class="add-card-data d-flex" style="align-items: center;margin-left: 20px;width: fit-content"><span>订单号：{{
                billData.order_no
              }}</span>
            </div>
          </div>
          <div class="take-dialog-open" v-if="billData.process_status == 4 && member.member_type != 4" @click="submitSjEdit">{{member.member_type == 1 ? '保存批注' : '提交修改'}}</div>
        </div>
        <div class="design-detail">
          <div style="position: relative">
            <img :src="billData.sjd_card ? billData.sjd_card.shejidan_img : ''" class="design-detail-img1">
            <template v-if="billData.process_status == 4">
              <Zwibbler ref="zwibblerSjDetail" :dataInfo1="pizhu_img2" :height="1096" :width="808"  />
            </template>
            <template v-else>
              <img :src="billData.design_card_pz_track_img ? billData.design_card_pz_track_img : ''"
                   class="design-detail-img2">
            </template>
          </div>
        </div>

      </el-dialog>

      <!-- 填写物流信息 -->
      <el-dialog :visible.sync="showPostDialog" custom-class="take-dialog" title="填写物流信息" width="326px">
        <div v-loading="deliveryFormLoading" class="post-form">
          <div>物流公司</div>
<!--          <input v-model="deliverForm.express_company" placeholder="请填写物流公司" type="text">-->
          <Input :placeholder="'请填写物流公司'" v-model="deliverForm.express_company"/>
          <div>物流单号</div>
<!--          <input v-model="deliverForm.express_no" placeholder="请填写物流单号" type="text">-->
          <Input :placeholder="'请填写物流单号'" v-model="deliverForm.express_no"/>
        </div>
        <div class="take-dialog-bottom">
          <div class="take-dialog-close" @click="showPostDialog = false">取消</div>
          <div class="take-dialog-open" @click="submitDelivery">提交</div>
        </div>
      </el-dialog>

      <!-- 设计单审核详情 todo-->
      <el-dialog :visible.sync="showConfirmDialog"
                 :close-on-click-modal="false"
                 custom-class="take-dialog"
                 title="设计单审核详情"
                 @close="dialogClose"
                 top="5vh"
                 width="1100px">
        <div class="confirm-warp">
          <div class="d-flex-between">
            <div class="designWarp-height">
              <div ref="designWarp" class="confirm-warp-left" :style="cutNewImg ? 'overflow: hidden;' : ''">
                <div class="d-flex" style="width: 100%;position: absolute;z-index: 4;left: 20px">
                  <div class="add-card-data" v-if="billData.patient" style="width: fit-content">
                    <span>{{ billData.patient.confirm_first_case_type_text ? '确认套餐类型' : '期望套餐类型' }}：</span><span
                    class="black-14">{{
                      billData.patient.confirm_first_case_type_text ? billData.patient.confirm_first_case_type_text : billData.patient.first_case_type_name
                    }}</span></div>
                  <div class="add-card-data d-flex" style="align-items: center;margin-left: 20px;width: fit-content"><span>订单号：{{
                      billData.order_no
                    }}</span>
                  </div>
                </div>
                <div v-show="!isCutOldOrNew" :key="isCutOldOrNew">
                  <Zwibbler  ref="zwibbler" :dataInfo1="pizhu_img" :height="1096"
                             :width="808" :bottom="'-80px'"></Zwibbler>
                </div>

                <img :src="billData.design_card_img" class="confirm-order" crossorigin="anonymous">
                <img v-show="isCutOldOrNew" :src="billData.design_card_pz_track_img" alt="" class="confirm-order-cover">
              </div>
            </div>
            <div class="confirm-warp-right">
              <textarea v-model="auditForm.content" placeholder="请填写设计单未通过的原因"></textarea>
            </div>
          </div>
          <div class="confirm-btn">
            <div @click="showConfirmDialog = false">暂不操作</div>
            <div style="margin-right: 0" @click="capture(false)">确认提交</div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Zwibbler from '@/components/Zwibbler'
import {CancelOrder, GetOrder, SavePizhu2} from "@/http/api";
import {compressionImage, dataURLtoFile, fileProcess} from "@/assets/js/imgHandle";
import {auditLog, auditRefer, confirm, delivery, update, doctorConfirmTechnicianSjd} from "@/http/order";
import axios from 'axios'
import JSZip from "jszip";
import FileSaver from "file-saver";

import ossUpload from "@/http/ossUpload";
import html2canvas from "html2canvas";

export default {
  name: "detail",
  components: {Zwibbler},
  data() {
    return {
      dialogVisible: false,
      showDetailDialog: false,
      showPostDialog: false,
      showConfirmDialog: false,
      billData: {},
      member: {},
      deliverForm: {
        id: undefined,
        express_company: undefined,
        express_no: undefined,
        delivery_type: 1, //1发货  2-修改
      },
      deliveryFormLoading: false,
      order_id: undefined,
      auditForm: {
        id: undefined,
        content: undefined,
        old_sjd_pz_img: undefined,
        new_sjd_pz_img: undefined,
        new_sjd_pz_track_img: undefined,
      },
      auditFormLoading: false,
      auditLog: [],
      fileList: {},
      pizhu_img: '',
      pizhu_img2: '',
      cutFile: null, // 截图后的文件保存
      base64DesignImg: null,
      showTrack: true,
      isCutOldOrNew: true,
      cutNewImg:false
    };
  },
  created() {
    this.order_id = this.$route.query.id;
    this.member = JSON.parse(localStorage.getItem("member"));
    this.$store.commit("breadChange", {
      name: "订单详情",
      isBack: true,
      url: "/bill_center",
    });
    this.getData();
  },
  methods: {
    getData() {
      GetOrder({id: this.order_id}).then((res) => {
        this.billData = res.data;
      });
    },
    showTrackChange(val) {
      this.showTrack = val
    },
    cancelOrder() {
      this.$confirm("确定取消订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        CancelOrder({id: this.billData.id}).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "取消成功",
            });
            this.getData();
            // this.$router.push("/bill_center");
          } else {
            this.$message.error(res.message[0] ? res.message[0] : "确认失败");
          }
        });
      });
    },
    openSjDetail() {
      let _this = this
      if (this.billData.design_card_pz_track_img) {
        fileProcess(this.billData.design_card_pz_track_img, new Date().getTime() + '.png').then(fileList => {
          compressionImage(fileList.raw, 808, 1096).then(fileRes => {
            ossUpload.bucketUpload(fileRes, (res) => {
              console.log(res.url)
              _this.pizhu_img2 = res.url
              this.showDetailDialog = true
            }, (err) => {
              this.$message({
                type: "error",
                message: '批注图片加载失败'
              })
            }, 'duole-images', '/upload/image/pc/temp/')
          })
        })
      } else {
        _this.pizhu_img2 = ''
        this.showDetailDialog = true
      }
    },
    /**订单确认  start */
    handleConfirm() {
      this.$confirm("是否确认订单?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return confirm({id: this.order_id});
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "确认成功",
            });
          } else {
            this.$message.error(res.message[0] ? res.message[0] : "确认失败");
          }
          this.getData();
        })
        .catch(() => {
        });
    },
    /**订单确认  end */

    /**发货相关  start */
    handleDelivery(type) {
      this.deliverForm = {
        id: this.billData.id,
        express_company: this.billData.express_company
          ? this.billData.express_company
          : undefined,
        express_no: this.billData.express_no
          ? this.billData.express_no
          : undefined,
        delivery_type: type,
      };
      this.showPostDialog = true;
    },
    // 发货or修改物流信息
    submitDelivery() {
      if (!this.deliverForm.id) {
        return this.$message.error("订单不能为空，请刷新后重试");
      }
      if (!this.deliverForm.express_company) {
        return this.$message.error("请输入物流公司");
      }
      if (!this.deliverForm.express_no) {
        return this.$message.error("请输入物流单号");
      }
      if (this.deliveryFormLoading) {
        return;
      }
      this.deliveryFormLoading = true;
      if (this.deliverForm.delivery_type == 1) {
        delivery(this.deliverForm)
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "发货成功",
              });
            } else {
              this.$message.error(res.message[0] ? res.message[0] : "发货失败");
            }
            this.deliveryFormLoading = false;
            this.showPostDialog = false;
            this.getData();
          })
          .catch(() => {
            this.deliveryFormLoading = false;
            this.showPostDialog = false;
            this.getData();
          });
      } else {
        update(this.deliverForm)
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "修改成功",
              });
            } else {
              this.$message.error(res.message[0] ? res.message[0] : "修改失败");
            }
            this.deliveryFormLoading = false;
            this.showPostDialog = false;
            this.getData();
          })
          .catch(() => {
            this.deliveryFormLoading = false;
            this.showPostDialog = false;
            this.getData();
          });
      }
    },
    /**发货相关  end */

    /**技师审核记录 start */
    handleAuditLog() {
      this.dialogVisible = true;
      this.getAuditLog();
    },
    getAuditLog() {
      auditLog({id: this.order_id}).then((res) => {
        if (res.code == 200) {
          this.auditLog = res.data;
        }
      });
    },
    /**技师审核记录 end */

    /**审核  start 打开设计单审核详情 */
    async handleAudit() {
      console.log(this.billData)
      let _this = this
      this.auditForm = {
        id: this.billData.id,
        content: undefined,
        old_sjd_pz_img: undefined,
        new_sjd_pz_img: undefined,
        new_sjd_pz_track_img: undefined,
      };
      if (this.billData.design_card_pz_track_img) {
        let fileList = await fileProcess(this.billData.design_card_pz_track_img, new Date().getTime() + '.png')
        compressionImage(fileList.raw, 808, 1096).then(fileRes => {
          ossUpload.bucketUpload(fileRes, (res) => {
            _this.pizhu_img = res.url
            _this.showConfirmDialog = true;
            _this.$nextTick(() => {
              _this.$refs.zwibbler.init()
              _this.capture('old')
            })
          }, (err) => {
            this.$message({
              type: "error",
              message: '批注图片加载失败'
            })
          }, 'duole-images', '/upload/image/pc/temp/')
        })
      } else {
        _this.pizhu_img = ''
        _this.showConfirmDialog = true;
        _this.auditForm.old_sjd_pz_img = _this.billData.sjd_card.shejidan_img
      }
    },
    submitAudit() {
      if (!this.auditForm.id) {
        return this.$message.error("订单不能为空，请刷新后重试");
      }
      if (!this.auditForm.content) {
        return this.$message.error("请填写设计单未通过的原因");
      }
      if (!this.auditForm.old_sjd_pz_img) {
        return this.$message.error("原批注后的设计单图片不能为空");
      }
      if (this.auditFormLoading) {
        return;
      }
      auditRefer(this.auditForm)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "审核成功",
            });
            this.showConfirmDialog = false;
            this.getData();
            location.reload()
          } else {
            this.$message.error(res.message[0] ? res.message[0] : "提交失败");
          }
          this.auditFormLoading = false;
        })
        .catch(() => {
          this.auditFormLoading = false;
          this.showConfirmDialog = false;
          this.getData();
          location.reload()
        });
    },
    /**审核  end */
    dialogClose(){
      //每次关闭弹窗记得隐藏注释
      this.isCutOldOrNew = true
    },
    //  截图方法
    async capture(type) {
      console.log('截图开始')
      let _this = this
      if(type){
        _this.isCutOldOrNew = true
        const html2canvas = require('html2canvas');
        await html2canvas(this.$refs.designWarp, {
          useCORS: true,
          allowTaint: true,
          backgroundColor: null
        }).then((canvas) => {
          //截图完成
          this.isCutOldOrNew = false
          this.cutNewImg = false
          let opt = {
            dataURL: canvas.toDataURL("image/png"),
            type: "image/png"
          }
          let cutFile = dataURLtoFile(opt, new Date().getTime() + '.png')
          ossUpload.bucketUpload(cutFile, (res) => {
            if(type == 'old') this.auditForm.old_sjd_pz_img = res.url
            else{
              //截图新的轨迹重合图并保存
              _this.auditForm.new_sjd_pz_img = res.url
              _this.submitAudit()
            }
          }, (err) => {

            this.$message({
              type: "error",
              message: '上传图片失败'
            })
          }, 'duole-images', '/upload/image/pc/refer_sjd_img/')
        })
      }else{
        //隐藏下面的批注条
        _this.cutNewImg = true
        let blob = this.$refs.zwibbler.saveTu()
        ossUpload.bucketUpload(blob, (trackRes) => {
          _this.auditFormLoading = false;
          _this.auditForm.new_sjd_pz_track_img = trackRes.url
          _this.capture('new')
        }, (err) => {
          console.log(err)
          this.$message({
            type: "error",
            message: '上传批注图片失败'
          })
        }, 'duole-images', '/upload/image/pc/new_sjd_pz_img/')
      }
    },
    submitSjEdit(){
      let blob = this.$refs.zwibblerSjDetail.saveTu()
      if(this.member.member_type == 1){
        ossUpload.bucketUpload(blob, (res) => {
          update({id:this.order_id,design_card_pz_track_img:res.url}).then(res=>{
            if(res.code == 200){
              this.showDetailDialog = false
              this.$message({
                type:'success',
                message:'保存成功'
              })
              this.getData()
            }else{
              this.$message({
                type:'error',
                message:res.message[0]
              })
            }
          })
        }, (err) => {
          this.$message({
            type: "error",
            message: '上传修改批注图片失败'
          })
        }, 'duole-images', '/upload/image/pc/edid_order/')
      }else{
        ossUpload.bucketUpload(blob, (res) => {
          doctorConfirmTechnicianSjd({id:this.order_id,design_card_pz_track_img:res.url}).then(res=>{
            if(res.code == 200){
              this.showDetailDialog = false
              this.$message({
                type:'success',
                message:'修改成功'
              })
              this.getData()
            }else{
              this.$message({
                type:'error',
                message:res.message[0]
              })
            }
          })
        }, (err) => {
          this.$message({
            type: "error",
            message: '上传修改批注图片失败'
          })
        }, 'duole-images', '/upload/image/pc/edid_order/')
      }


    },
    downloadFile(){
      if(this.billData.model_file_url){
        this.$message({
          type:'info',
          message:'开始下载'
        })
        let list = this.billData.model_file_url.split(',')
        this.download1(list)
      }else{
        this.$message({
          type:'info',
          message:'暂无文件'
        })
      }
    },
    download1(list){
      var videoData = list;
      const zip = new JSZip();
      var promises = [];
      videoData.forEach(item => {
        const promise = this.getFile(item).then(data => {
          const arr_name = item.split("/");
          const file_name = arr_name[arr_name.length - 1];
          // 获取文件名console.log(data)
          zip.file(file_name, data, { binary: true });
        });
        promises.push(promise);
      });
      Promise.all(promises).then(() => {
        console.log("全部下载完成");
        zip.generateAsync({ type: "blob" }).then(content => {
          // 生成二进制流
          console.log("生成压缩包");
          FileSaver.saveAs(content, "数字模型文件.zip");
        });
      });
      },
    getFile(url){
      return new Promise((resolve, reject) => {
        axios({method: "get",url:url,responseType: "blob"}).then(data => {
          resolve(data.data);
        }).catch(error => {
          reject(error.toString());
        });
      });
      },
  }
};
</script>

<style scoped>
@import "../../assets/css/bill_center.css";
</style>
